import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { TableComp, FormUtils as GetAllFormFields } from "sz-react-utils";
import { Card, Select, Col, Row, Button, Drawer, Form, notification, DatePicker, Tooltip, Popconfirm } from "antd";
import axios from "axios"; // For API requests
import Request, { API_URL } from "../../request";
import _ from 'lodash';
import moment from "moment";
import async from 'async';
import { RightsWrapper } from "../../components/_utils/utils";
const { Option } = Select;
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
const { RangePicker } = DatePicker;
let submittedUsers = [];
@Form.create()
class AddDetailDrawer extends React.Component {
    state = {
        visible: true,
        users: [],
        submissionStatus: '',
        loading: false
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 500)
    }

    loadUsers = async () => {
        let { alreadySubmittedUsers } = this.props;
        let params = {
            results: 1000,
            count: 1000,
            active: true,
            userType: { $ne: "Student" },
            userBranch: activeUser.userBranch,
            alreadySubmittedUsers: alreadySubmittedUsers,
        }
        let response = await Request.loadUser(params);
        response.data = response.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.name })
            return temp;
        }, [])
        this.setState({ users: response.data })
    }


    handleSubmit = (e) => {
        let { form } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            if (values.submissionStatus === "Not Collected" && !values.notSubmitReason) {
                notification.error({
                    message: 'Choose Not Collected Reason'
                })
                return false
            }
            this.setState({ loading: true })
            let response = await Request.addPhoneSubmission(values);
            this.setState({ loading: false })
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }

    componentDidMount() {
        this.loadUsers()
    }

    render() {
        let { visible, users } = this.state
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        let inputTypes = {
            fields: [
                {
                    label: 'Select User',
                    key: 'userId',
                    type: 'select',
                    showSearch: true,
                    required: true,
                    options: users,
                    onChange: v => {
                        setFieldsValue({ userId: v })
                    }
                },
                {
                    label: 'Status',
                    key: 'submissionStatus',
                    type: 'select',
                    options: ['Collected', 'Not Collected', 'Returned'],
                    required: true,
                    onChange: v => {
                        setFieldsValue({ submissionStatus: v }, () => {
                            this.setState({ submissionStatus: v })
                        })
                    }
                },
                {
                    label: 'Not Collected Reason',
                    key: 'notSubmitReason',
                    type: 'select',
                    options: ['Not Carrying', 'Permitted By Management', 'Carried but Not Submitted'],
                    required: this.state.submissionStatus === "Not Collected" ? true : false,
                    hidden: this.state.submissionStatus === "Not Collected" ? false : true,
                    onChange: v => {
                        setFieldsValue({ notSubmitReason: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={`Add Phone Details`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={600}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} apiurl={API_URL} getFieldDecorator={getFieldDecorator} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}



class EmployeePersonalPhones extends React.Component {
    state = {
        count: 0,
        showDrawer: false,
        users: [],
        alreadySubmittedUsers: [],
        submissionDate: {
            from: moment().startOf('day'),
            to: moment().endOf('day')
        }
    };

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    componentDidMount() {
        this.loadUsers()
    }

    openDrawer = () => {
        this.setState({ showDrawer: true })
    }

    onCloseDrawer = () => {
        this.setState({ showDrawer: false }, () => {
            this.table.current.reload();
        })
    }

    loadUsers = async () => {
        let params = {
            results: 1000,
            count: 1000,
            active: true,
            userType: { $ne: "Student" },
            userBranch: activeUser.userBranch
        }
        let response = await Request.loadUser(params);
        response.data = response.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.name })
            return temp;
        }, [])
        this.setState({ users: response.data })
    }

    updateStatus = async (data) => {
        let shiftTimings = activeUser.shiftTiming.split(' - ');
        const shiftEndTime = moment(shiftTimings[1], "HH:mm A");
        const currentTime = moment();
        const differenceInMinutes = shiftEndTime.diff(currentTime, 'minutes');
        if (data.submissionStatus === "Returned" && differenceInMinutes > 15) {
            let returnReason = prompt('Enter Return Reason');
            if (!returnReason || returnReason.trim() === "") {
                notification.error({ message: 'Reason for return is required!' });
                return;
            } else {
                data.returnReason = returnReason;
            }
        }
        let response = await Request.updateSubmissionStatus(data);
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }

    deleteData = async (recordId) => {
        let response = await Request.deletePhoneSubmission({ _id: recordId })
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload()
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                submissionDate: {
                    from: date[0],
                    to: date[1],
                },
            },
            () => {
                this.table.current.reload();
            }
        );
    };

    onOk = value => {
        this.table.current.reload();
    }


    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.submissionDate = this.state.submissionDate;
            params.branchId = activeUser.userBranch;
            let response = await Request.getPhoneSubmission(params);
            let alreadySubmittedUsers = [];
            async.each(response.data, (user) => {
                alreadySubmittedUsers.push(user.userId._id.toString())
            })
            this.setState({ count: response.total, alreadySubmittedUsers: alreadySubmittedUsers })
            return resolve(response)
        });
    };

    render() {
        const { count, showDrawer, users, alreadySubmittedUsers } = this.state;

        const columns = [
            {
                title: "Sr. No.",
                key: "serialNumber",
                render: (text, record, index) => <div>{index + 1}</div>,
            },
            {
                title: 'Employee Name',
                key: 'userId',
                dataIndex: 'userId.name',
                filters: users.map(x => ({ value: x._id, text: x.display })),
                filterRegex: true
            },
            {
                title: 'Submission Status',
                key: 'submissionStatus',
                filters: [
                    { value: 'Collected', text: 'Collected' },
                    { value: 'Not Collected', text: 'Not Collected' },
                    { value: 'Returned', text: 'Returned' }
                ]
            },
            {
                title: 'Not Collected Reason',
                key: 'notSubmitReason',
            },
            {
                title: 'Collected Timings',
                key: 'collectedTime',
                render: (text, record) => (
                    record.collectedTime ?
                        record.collectedTime.map((time) => {
                            return (
                                <div>{moment(time).format('HH:mm A')}<hr /></div>
                            )
                        })
                        : null
                )
            },
            {
                title: 'Returned Timings',
                key: 'returnedTime',
                render: (text, record) => (
                    record.returnedTime ?
                        record.returnedTime.map((time) => {
                            return (
                                <div>{moment(time).format('HH:mm A')}<hr /></div>
                            )
                        })
                        : null
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <div>
                        {
                            record.submissionStatus === "Collected" ?
                                <Tooltip title="Returned" >
                                    <Button style={{ marginRight: 2 }} shape="circle" icon="backward" size="small" onClick={() => this.updateStatus({ _id: record._id, submissionStatus: 'Returned' })}></Button>
                                </Tooltip>
                                :
                                <Tooltip title="Collected" style={{ marginRight: 10 }}>
                                    <Button style={{ marginRight: 2 }} shape="circle" icon="forward" size="small" onClick={() => this.updateStatus({ _id: record._id, submissionStatus: 'Collected' })}></Button>
                                </Tooltip>
                        }
                        <RightsWrapper myRight={"employeesPhones.delete"}>
                            <Tooltip title="Delete">
                                <Popconfirm title="Are you sure to Delete?" onConfirm={() => this.deleteData(record._id)}>
                                    <Button shape="circle" icon="delete" size="small" />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </div>
                )
            }
        ];

        return (
            <PageHeaderWrapper title={`Employees Personal Phones: ${count}`}>
                {
                    showDrawer ?
                        <AddDetailDrawer alreadySubmittedUsers={alreadySubmittedUsers} onClose={this.onCloseDrawer} />
                        : null
                }
                <Card bordered={true} style={{ marginBottom: 10 }}>
                    <Row gutter={16}>
                        <Col span={8}>
                            <RangePicker
                                defaultValue={[moment(this.state.submissionDate.from), moment(this.state.submissionDate.to)]}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            /></Col>
                        <Col span={4}>
                            <Button type="primary" onClick={() => this.openDrawer()}>Add</Button>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePersonalPhones);
